
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/confirmation",
      function () {
        return require("private-next-pages/confirmation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/confirmation"])
      });
    }
  